import { CELERY_STATUSES } from "@shared/constants";
import { getTaskFromJobId, GetTaskFromJobIdReturnType } from "./api";

/**
 * Accepts a job_id and returns a url related to the document being requested
 * @param taskID The job ID to send to the loader api (/api/celery/)
 * @param opts Any additional options for the loader
 */
export const taskLoader = (
  taskID: string,
  opts?: any // eslint-disable-line
): GetTaskFromJobIdReturnType => {
  const newOpts = {
    ...opts,
    delay: opts?.delay ? opts.delay : 2000, // How long to wait in between polls, in milliseconds
    maxAttempts: opts?.count ? opts.count : 100, // Max number of times to poll
  };

  const statuses = CELERY_STATUSES;
  let attempts = 0;

  const poll = (): Promise<GetTaskFromJobIdReturnType> => {
    return new Promise((resolve, reject) => {
      // Check if we've exceeded max attempts
      if (attempts >= newOpts.maxAttempts) {
        reject(
          new Error(
            `Task polling timed out after ${attempts} attempts (${
              (attempts * newOpts.delay) / 1000
            }s)`
          )
        );
        return;
      }

      attempts += 1;

      // Wait specified time
      setTimeout(() => {
        getTaskFromJobId(taskID) // Poll celery task
          .then((response: GetTaskFromJobIdReturnType) => {
            const { state } = response;

            if (state === statuses.SUCCESS.id) {
              // Task complete!
              resolve(response);
            } else if (
              state === statuses.PENDING.id ||
              state === statuses.RETRY.id
            ) {
              // Continue polling
              resolve(poll());
            } else if (state === statuses.FAILURE.id) {
              // Failed, return error
              reject(response);
            } else {
              // Unknown state; return error
              reject(response);
            }
          })
          .catch((error) => {
            reject(error);
          });
      }, newOpts.delay);
    });
  };

  return poll() as unknown as GetTaskFromJobIdReturnType;
};
